<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-05-09 09:24:59
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-05-11 14:32:49
 * @FilePath: \english_admin\src\views\home\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>用户数据展示</div>
</template>
<script>
export default{
   name:"index",
   data(){
  return {
  
  }
  }
}
</script>
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/views/home/index.vue